import { createContext, type ReactNode } from 'react'

import type {
  HorizontalAlignment,
  Options,
  VerticalAlignment,
} from './toastTypes'

export type ToastContextType = {
  add: (content: ReactNode, opts?: Options) => string
  remove: (id: string) => void
  horizontalAlignment: HorizontalAlignment
  verticalAlignment: VerticalAlignment
}

export const ToastContext = createContext<null | ToastContextType>(null)
